import { useState } from "react";

import { Button } from "atoms/button/Button";
import { TextButton } from "atoms/text-button/TextButton";

import { PersonalisationHeading } from "./PersonalisationHeading";
import { PersonalisationProgressBar } from "./PersonalisationProgressBar";
import { PersonalisationScreenLayout } from "./PersonalisationScreenLayout";

interface JourneyDetailsProps {
  onContinue: (text: string) => void;
  onSkip?: () => void;
  progressPercentage: number;
  onBack?: () => void;
  onClose?: () => void;
  placeholder?: string;
  label?: string;
  initialText?: string;
}

export const JourneyDetails = ({
  onContinue,
  onSkip,
  progressPercentage,
  onBack,
  onClose,
  placeholder = "Which treatments have helped shape your results so far?",
  label = "Some experience, exploring further",
  initialText,
}: JourneyDetailsProps) => {
  const [text, setText] = useState(initialText ?? "");

  const handleContinue = () => {
    onContinue(text);
  };

  const handleSkip = () => {
    onSkip?.();
  };

  const handleBack = () => {
    onBack?.();
  };

  const handleClose = () => {
    onClose?.();
  };

  return (
    <PersonalisationScreenLayout
      header={
        <PersonalisationProgressBar
          progressPercentage={progressPercentage}
          onBack={handleBack}
          onClose={handleClose}
        />
      }
      footer={
        <>
          <Button
            style="primary"
            size="large"
            fullWidth
            disabled={text.length === 0}
            onClick={handleContinue}
          >
            Continue
          </Button>

          <TextButton variant="secondary" onClick={handleSkip}>
            Skip for now
          </TextButton>
        </>
      }
    >
      <PersonalisationHeading size="sm">
        Every journey is unique — where are you on yours?
      </PersonalisationHeading>

      <div className="flex flex-col items-start self-stretch rounded-[13px] bg-white/40 p-4">
        <label htmlFor="journey-details" className="mb-2 pl-2 text-body1">
          {label}
        </label>
        <textarea
          name="journey-details"
          id="journey-details"
          defaultValue={initialText}
          style={{
            boxShadow: "none",
          }}
          className="w-full resize-none rounded-md bg-white p-2 outline-none placeholder:text-secondary/70 focus:border-none focus:outline-none"
          rows={5}
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={placeholder}
        />
      </div>
    </PersonalisationScreenLayout>
  );
};
